<template>
  <li class="list" :class="{ active: show }">
    <a href="#" @click="show = !show">{{ category.label }} </a>
    <ul class="items">
      <li>
        <a href="javascript:void(0)" @click="loadCategory(category.id)"
          >Todo de {{ category.label }}</a
        >
      </li>
      <template v-for="child in category.children">
        <Collapse
          :category="child"
          @onLoadProducts="loadProducts"
          @onCopyLink="copy"
          :key="'child-cat-' + child.id"
        ></Collapse>
      </template>
      <li class="" v-for="brand in sort(category.brands)">
        <div class="list-element" @click="loadCategory(category.id, brand._id)">
          <a href="javascript:void(0)">{{ brand.name }}</a>

          <a href="javascript:void(0)" @click="copy(category.id, brand._id)"
            ><i class="share alternate icon"></i
          ></a>
        </div>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  name: "Collapse",
  props: ["category"],
  data() {
    return {
      show: false,
    };
  },
  methods: {
    sort(array) {
      const sorted = array.concat();

      return _.orderBy(sorted, "name", "asc");
    },
    loadCategory: function (categoryId, brandId) {
      const payload = {
        category: categoryId | null,
        brand: brandId,
      };

      this.$emit("onLoadProducts", payload);
    },

    loadProducts: function (payload) {
      this.$emit("onLoadProducts", payload);
    },
    copy: function (payload) {
      this.$emit("onCopyLink", payload);
    },
  },
  components: {
    Collapse: () => import("./Collapse.vue"),
  },
};
</script>

<style>
.list-element {
  display: flex;
  max-width: 400px;
}
</style>
